@import 'variants';

/**
    @prop --uic-button-min-width: min-width of the default button
    @prop --uic-button-height: height of the default button
    @prop --uic-icon-button-width: width of the icon-sized button
    @prop --uic-icon-button-height: height of the icon-sized button
    @prop --uic-stretched-button-width: width of the stretched-sized button
    @prop --uic-stretched-button-height: height of the stretched-sized button
*/

uic-button {
  box-sizing: border-box;
  display: inline-block;
  padding: 8px;
  position: relative;

  .uic-button__native-button {
    @include font(normal, bold);
    align-items: center;
    border: 1px solid transparent;
    border-radius: 0;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    justify-content: center;
    outline: 2px solid transparent;
    outline-offset: -2px;
    padding: 0 16px;
    position: relative;
    // prevent distracting highlight when pressing
    -webkit-tap-highlight-color: transparent;
    text-decoration: none;
    user-select: none;
    width: 100%;

    .uic-button__loading {
      height: 100%;
      position: relative;
    }

    &.loading {
      pointer-events: none;

      .uic-button__label,
      .uic-button__icon {
        display: none;
      }

      svg {
        width: auto; // Added for safari. Else SVG has full width.
      }
    }

    &::before {
      @include absolute();
      background: transparent;
      content: '';
    }

    &:disabled {
      font-weight: normal;
      pointer-events: none;
    }
  }

  .uic-button__label {
    @include truncate();
  }

  &[loading],
  &[disabled]:not([disabled='false']) {
    pointer-events: none;
  }
}

uic-button[size='default'] .uic-button__native-button {
  height: var(--uic-button-height);
  min-width: var(--uic-button-min-width);
}

uic-button[size='icon'] .uic-button__native-button {
  height: var(--uic-icon-button-height);
  padding: 0;
  width: var(--uic-icon-button-width);
}

uic-button[size='icon-stretched'] .uic-button__native-button {
  height: var(--uic-stretched-button-height);
  padding: 0;
  width: var(--uic-stretched-button-width);
}

// SLOT SUPPORT

uic-button slot-fb {
  display: flex;
}

uic-button[size='default'] .uic-button__icon--custom,
uic-button[size='default'][icon] .uic-button__icon {
  margin-right: 8px;
}

.uic-button__icon--custom {
  height: var(--uic-icon-height);
  width: var(--uic-icon-width);

  svg {
    height: 100%;
    width: 100%;
  }
}
